/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPlayerTrackNext = createReactComponent("outline", "player-track-next", "IconPlayerTrackNext", [["path", { "d": "M3 5v14l8 -7z", "key": "svg-0" }], ["path", { "d": "M14 5v14l8 -7z", "key": "svg-1" }]]);

export { IconPlayerTrackNext as default };
//# sourceMappingURL=IconPlayerTrackNext.mjs.map
